import _JSXStyle from "styled-jsx/style";
import { useDhis2ConnectionStatus, useOnlineStatusMessage } from '@dhis2/app-runtime';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import i18n from './locales/index.js';
import styles from './online-status.styles.js';
/** A badge to display online/offline status in the header bar */

export function OnlineStatus(_ref) {
  let {
    dense
  } = _ref;
  const {
    isConnected: online
  } = useDhis2ConnectionStatus();
  const {
    onlineStatusMessage
  } = useOnlineStatusMessage();
  const displayStatus = online ? i18n.t('Online') : i18n.t('Offline');
  return /*#__PURE__*/React.createElement("div", {
    "data-test": "headerbar-online-status",
    className: "jsx-".concat(styles.__hash) + " " + (cx('container', dense ? 'bar' : 'badge') || "")
  }, onlineStatusMessage && !dense && /*#__PURE__*/React.createElement("span", {
    className: "jsx-".concat(styles.__hash) + " " + "info unselectable"
  }, onlineStatusMessage), /*#__PURE__*/React.createElement("div", {
    className: "jsx-".concat(styles.__hash) + " " + (cx('icon', online ? 'online' : 'offline') || "")
  }), /*#__PURE__*/React.createElement("span", {
    className: "jsx-".concat(styles.__hash) + " " + "label unselectable"
  }, displayStatus), onlineStatusMessage && dense && /*#__PURE__*/React.createElement("span", {
    className: "jsx-".concat(styles.__hash) + " " + "info-dense unselectable"
  }, onlineStatusMessage), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: styles.__hash
  }, styles));
}
OnlineStatus.propTypes = {
  /** If true, displays as a sub-bar instead of a badge */
  dense: PropTypes.bool
};